module.exports = __webpack_public_path__ + "static/013-493999932aa22e623a9fbd81b0c0087b.png";